'use strict';

import React, { Component, Fragment } from 'react';
import is from 'is_js';
import uniqid from 'uniqid';
import numeral from 'numeral';
import moment from 'moment';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import TextInput from 'Components/Forms/Elements/TextInput';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import BackEtablishmentsBlock from 'Components/Blocks/BackEtablishmentsBlock';
import BackBookingComponent from 'Components/Blocks/BackBookingComponent';
import BackSpacesBlock from 'Components/Blocks/BackSpacesBlock';
import MuiPhoneNumber from 'material-ui-phone-number';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getStateFromObject from 'Components/Forms/Functions/getStateFromObject';
import handleChange from 'Components/Forms/Functions/handleChange';
import getFormData from 'Components/Forms/Functions/getFormData';
import CustomerPicking from 'Components/Back/CustomerPicking';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import { action, URL } from 'Shared/Routes';
import { safeNumeral, getBookingHoursCount, getOpenInfos } from 'Shared/utilities';
import { days_config, b_seminar_ranges } from 'Shared/options';
import bemit from 'Functions/bemit';
import Loader from 'Pure/Loader';
let app = window.app;
const qwest = window.qwest;
export default class ModuleBookingForm extends Component {
  state = {
    step: 0,
    create_account: true,
    search_id: uniqid(),
    status_messages: {},
    need_availability: false,
    showPassword: false
  };
  handleChange = handleChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchModuleBooking();
    }
    component.fetchEtablishments();
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.space && component.need_availability === true) {
      component.fetchAvailability({});
    }
  }
  fetchModuleBooking = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    let pathname = document.location.pathname;
    if (document.location.pathname.endsWith('/')) {
      pathname = pathname.slice(0, -1);
    }
    const id = props.id || pathname.slice(pathname.lastIndexOf('/') + 1);
    qwest.post('/booking/get-all', {
      id: id,
      with_count: false
    }).then(function (xhr, response) {
      const update = getStateFromObject({
        data: response.data[0],
        model: 'booking'
      });
      component.setState({
        ...update,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  fetchEtablishments = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post(action('getAllFrontEtablishments'), {
      skip: 0,
      limit: 0,
      source: 'module-booking-form',
      type: 'b_seminar'
    }).then(function (xhr, response) {
      component.setState({
        etablishments: response.data
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  searchCustomer = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post(action('getAllUsers'), {
      searched: state.customer_searched,
      role: "customer",
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        cutomer_search_result: response.data,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = Object.keys(state).filter(key => key.startsWith('booking[')).reduce(function (update, key) {
      if (is.string(state[key])) {
        update[key] = '';
      } else if (is.array(state[key])) {
        update[key] = [];
      } else if (is.json(state[key])) {
        update[key] = {};
      }
      return update;
    }, {});
    component.setState(update);
  };
  nextStep = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.step === 0) {
      if (state['user[lastname]'] === "") {
        return component.setState({
          status_messages: {
            'user[lastname]': {
              error: "Champ requis"
            }
          }
        });
      }
      if (state['user[firstname]'] === "") {
        return component.setState({
          status_messages: {
            'user[firstname]': {
              error: "Champ requis"
            }
          }
        });
      }
      if (state['user[login]'] === "") {
        return component.setState({
          status_messages: {
            'user[login]': {
              error: "Champ requis"
            }
          }
        });
      }
      if (state['user[password]'] === "") {
        return component.setState({
          status_messages: {
            'user[password]': {
              error: "Champ requis"
            }
          }
        });
      }
      if (state['user[password]'] !== state["password-verification"]) {
        return component.setState({
          status_messages: {
            'password-verification': {
              error: "Les mots de passe ne correspondent pas"
            }
          }
        });
      }
      component.setState({
        user: {
          lastname: state['user[lastname]'],
          firstname: state['user[firstname]'],
          login: state['user[login]'],
          password: state['user[password]'],
          phone_number: state['user[phone_number]']
        }
      });
    }
    component.setState({
      step: state.step + 1
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const booking = getFormData({
      state: state,
      pattern: 'booking['
    });
    const url = props.type === 'update' ? '/module-booking/update' : '/module-booking/create';
    qwest.post(url, booking).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchBooking();
      } else {
        component.clearForm();
        window.setTimeout(function () {
          app.navigateTo(URL('AdminBookingsModuleDashboard'));
        }, 2000);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  selectCustomer = customer_id => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!state.cutomer_search_result || !customer_id) return;
    let customer = (state.cutomer_search_result || []).find(customer => customer.id === customer_id);
    component.setState({
      'user[lastname]': customer.lastname || '',
      'user[firstname]': customer.firstname || '',
      'user[login]': customer.login || '',
      'user[phone_number]': customer.phone_number || '',
      'user[id]': customer.id || '',
      user: customer,
      create_account: false,
      step: 1
    });
  };
  handlePhoneChange = value => {
    const component = this,
      props = this.props,
      state = this.state;
    component.handleChange({
      e: undefined,
      value: value,
      name: 'user[phone_number]'
    });
  };
  selectEtablishment = id => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      etablishment_id: id,
      step: 2
    });
  };
  goBack = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      step: state.step - 1
    });
  };
  selectSpace = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      people: window.localStorage.getItem('widget-people') || '',
      date: window.localStorage.getItem('widget-date') || '',
      start: window.localStorage.getItem('widget-start') || '',
      end: window.localStorage.getItem('widget-end') || '',
      amount: window.localStorage.getItem('amount') || '',
      disposition: window.localStorage.getItem('widget-disposition') || '',
      step: 3
    });
    component.fetchSpace();
  };
  fetchSpace = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const space_id = window.localStorage.getItem('booking-space-id');
    if (!space_id) {
      return component.setState({
        error: 'Veuillez sélectionner un espace ' + 'avant de procéder à une réservation.'
      });
    }
    component.setState({
      loading: true
    });
    qwest.post(action('getAllFrontSpaces'), {
      id: space_id,
      striptags: false
    }).then(function (xhr, response) {
      const space = response.data?.[0];
      if (!space) {
        return component.setState({
          error: 'Espace introuvable.'
        });
      }
      component.need_availability = true;
      component.setState({
        space: space,
        hours_count: getBookingHoursCount({
          date: state.date,
          start_hour: state.start,
          end_hour: state.end,
          coworking_space: space
        })
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleClickShowPassword = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      showPassword: !state.showPassword
    });
  };
  handleMouseDownPassword = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.preventDefault();
  };
  fetchAvailability = ({
    date,
    people
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!date && !state.date || !state.space) return;
    component.need_availability = false;
    const people_count = typeof people === 'undefined' ? parseInt(safeNumeral(state.people)) : parseInt(safeNumeral(people));
    const date_value = date || state.date;
    component.setState({
      loading: true,
      date: date_value
    });
    const ISO_date = moment(date_value).format('YYYY-MM-DD');
    const [is__open, is__custom] = getOpenInfos({
      schedule: state.space.schedule,
      availability: state.space.availabilities,
      type: state.space.type,
      date: ISO_date
    });
    if (!is__open) {
      return component.setState({
        loading: false,
        closed: true,
        special_closing: is__custom
      });
    }
    const seats = numeral(safeNumeral(state.space.number_seat)).format('0');
    qwest.post(action('getSpaceBooking'), {
      coworking_space_id: state.space.id,
      date: date_value
    }).then(function (xhr, response) {
      numeral.locale('en');
      moment.locale('fr');
      const day = days_config[moment(date).isoWeekday() - 1];
      let availability = [];
      if (state.space.type === 'a_calm_coworking_space') {
        const schedule = state.space.schedule[day] || {};
        const hours_range = numeral(safeNumeral(schedule.to)).subtract(safeNumeral(schedule.from)).value();
        availability.length = hours_range;
        availability = Array.from(availability).map(function (nothing, i) {
          const start_hour = numeral(safeNumeral(schedule.from)).add(i).format('0');
          const infos = {
            start: start_hour + 'h',
            end: numeral(start_hour).add(1).format('0') + 'h'
          };
          const booking_infos = response.booking.find(booking => booking.hour === start_hour);
          infos.remaining_seats = numeral(seats).subtract(safeNumeral(booking_infos?.people_count)).format('0');
          if (infos.remaining_seats < 0) infos.remaining_seats = '0';
          infos.too_little_seats = infos.remaining_seats < people_count;
          return infos;
        });
        component.setState({
          availability: availability
        });
      } else if (state.space.type === 'b_seminar') {
        const bookings = response.booking || [];
        availability = b_seminar_ranges.filter(opt => opt.value !== 'day').map(function (config, i) {
          const infos = {
            start: config.value
          };
          if (bookings?.[0]?.type === 'day') {
            infos.available = false;
          } else {
            const [is__open, is__custom] = getOpenInfos({
              schedule: state.space.schedule,
              availability: state.space.availabilities,
              type: state.space.type,
              date: date_value,
              period: config.value
            });
            infos.available = is__open;
            if (is__custom && !is__open) {
              infos.available_type = 'close';
            }
            if (is__open) {
              const booking = bookings.find(booking => booking.type === config.value);
              infos.available = !booking;
            }
          }
          return infos;
        });
        component.setState({
          availability: availability
        });
      }
      component.setState({
        closed: false,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      if (!component.requests['fetchAvailability']) return;
      delete component.requests['fetchAvailability'];
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement("div", {
      className: props.paper !== false ? 'c-paper' : undefined
    }, state.step === 0 ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(CustomerPicking, {
      status: state.status_messages,
      cutomer_search_result: state.cutomer_search_result,
      selectCustomer: component.selectCustomer,
      loader: loader,
      handleChange: component.handleChange,
      customer_searched: state.customer_searched,
      searchCustomer: component.searchCustomer
    }), state?.cutomer_search_result && state?.cutomer_search_result.length === 0 ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "u-text-center u-margin-top-20"
    }, "Ou cr\xE9er un client"), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[lastname]'],
      name: "user[lastname]",
      label: "Nom",
      variant: "outlined",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[firstname]'],
      name: "user[firstname]",
      label: "Pr\xE9nom",
      variant: "outlined",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(MuiPhoneNumber, {
      onChange: component.handlePhoneChange,
      className: "c-form-element c-form-element--reservation",
      value: state['user[phone_number]'],
      onlyCountries: ['fr'],
      defaultCountry: "fr",
      countryCodeEditable: true,
      label: "Num\xE9ro de t\xE9l\xE9phone",
      variant: "outlined",
      fullWidth: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[login]'],
      className: "c-form-element c-form-element--reservation",
      name: "user[login]",
      type: "text",
      label: "E-mail",
      autocomplete: "new-email",
      variant: "outlined",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['user[password]'],
      required: true,
      name: "user[password]",
      type: state.showPassword ? 'text' : 'password',
      label: "Mot de passe (12 caract\xE8res min.)",
      className: "c-form-element c-form-element--reservation",
      variant: "outlined",
      autocomplete: "new-password",
      suffix: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(IconButton, {
        "aria-label": "Voir le mot de passe",
        onClick: component.handleClickShowPassword,
        onMouseDown: component.handleMouseDownPassword,
        edge: "end"
      }, state.showPassword ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null))),
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['password-verification'],
      required: true,
      name: "password-verification",
      type: state.showPassword ? "text" : "password",
      label: "Retapez le mot de passe (12 caract\xE8res min.)",
      className: "c-form-element c-form-element--reservation",
      variant: "outlined",
      autocomplete: "new-password",
      suffix: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(IconButton, {
        "aria-label": "Voir le mot de passe",
        onClick: component.handleClickShowPassword,
        edge: "end",
        onMouseDown: component.handleMouseDownPassword
      }, state.showPassword ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null))),
      status: state.status_messages
    }))), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center\r u-margin-top-25 u-padding-bottom-20 "
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.nextStep
    }, "Choisir l'\xE9tablissement", loader))) : undefined) : state.step === 1 ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, {
      type: "button",
      onClick: component.goBack,
      className: bemit('c-arrow-btn', ['primary'])
    }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
      className: "c-arrow-btn__arrow"
    }), /*#__PURE__*/React.createElement("span", {
      className: "c-arrow-btn__text"
    }, "Retour \xE0 l'\xE9tape pr\xE9c\xE9dente")), /*#__PURE__*/React.createElement(BackEtablishmentsBlock, {
      bemit: ['search-results', 'search-results-back'],
      pagination: false,
      selectEtablishment: component.selectEtablishment,
      type: "b_seminar",
      key: state.search_id,
      source: "module-booking-form"
    })) : state.step === 2 ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, {
      type: "button",
      onClick: component.goBack,
      className: bemit('c-arrow-btn', ['primary'])
    }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
      className: "c-arrow-btn__arrow"
    }), /*#__PURE__*/React.createElement("span", {
      className: "c-arrow-btn__text"
    }, "Retour \xE0 l'\xE9tape pr\xE9c\xE9dente")), state.etablishment_id ? /*#__PURE__*/React.createElement(BackSpacesBlock, {
      "etablishment-id": state.etablishment_id,
      "layout-type": "side",
      selectSpace: component.selectSpace,
      title: false
    }) : undefined) : state.step === 3 ? /*#__PURE__*/React.createElement(Fragment, null, state.space && state.availability ? /*#__PURE__*/React.createElement(BackBookingComponent, {
      space: state.space,
      availability: state.availability,
      date: state.date,
      people: state.people,
      start: state.start,
      end: state.end,
      amount: state.amount,
      disposition: state.disposition,
      create_account: state.create_account,
      user: state.user,
      goBack: component.goBack,
      hours_count: state.hours_count
    }) : 'Espace non disponible') : 'Impossible de charger l\'espace');
    return output;
  }
}
